<template>
  <div class="dropdown-wrapper">
    <button class="btn" @click="$emit('manage_display', index)">
      {{ placeholder }}
      <div class="material-icons dropdown-btn">
        {{ this.close_icon }}
      </div>
    </button>
    <div v-show="display" class="dropdown">
      <ul>
        <li v-for="(values, i) in value" :key="i" @click="$emit('select_filter', my_key, values); $emit('manage_display', index);">
          <label>
            <input type="hidden" name="test" />{{ $t(values.name) }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import specs from "@/specs"

export default {
  name: "Dropdown",
  props: {
    my_key: String,
    details_search: [String, Object],
    placeholder: String,
    value: Array,
    index: Number,
    display: Boolean
  },
  data :() => {
    return {
      close_icon: specs._CLOSE_ICON,
    }
  },
}
</script>